module.exports = __webpack_public_path__ + "static/11-1a0e602d8d87c91ba76739b4d1e81aa6.jpeg";